import React from 'react'
import { CartProductBlock, CartProductQuantity, CartProductTitle, CartProductTitleBlock, CartProductWrapper } from '../index.styled'
import CartProduct from '../CartProduct'

const CartMenu = React.memo(({ item, index }) => {
	const dataTestId = `menu-${index}-${item?.name}`
	const isCanceledItem = item?.status === 'CANCELED'
	const titleLayout = isCanceledItem ? 'canceled ' : ''

	return (
		<CartProductWrapper data-testid={dataTestId}>
			<CartProductBlock>
				<CartProductTitleBlock>
					<CartProductTitle className={titleLayout}>{item?.name}</CartProductTitle>
					<CartProductQuantity className={titleLayout} data-testid={dataTestId + '-quantity'}>x{item?.quantity}</CartProductQuantity>
				</CartProductTitleBlock>
				{item?.items.map((subItem, i) =>
					<CartProduct key={i}
											 item={subItem}
											 index={i}
											 isMenuCanceled={isCanceledItem}
											 isMenuProduct={true} />)}
			</CartProductBlock>
		</CartProductWrapper>
	)
})

CartMenu.displayName = 'CartMenu'
export default CartMenu
